export default function stringIsEmpty(value: string | null | undefined): boolean {
    if (value == null) {
        return true;
    }

    return !value.length;
}
